import React, { useState } from 'react'
import "./MobileHeaderStyle.css"
import { Logo } from "../Iocn/iocn";



export const MobileHeader = ({toggleSidebar, sidebarType}) => {
    // console.log("what is in the activeItemIdsss", activeItemId)

    

   

    return (
        <div>
            <header className="header">
                <div className='leftWrapper'>
                    <div className="logos">
                        {Logo}
                        <h2>MagicCha</h2>
                    </div>
                    
                    {/* <div className='dummyList'>
                        <p>A</p>
                        <p>B</p>
                        <p>C</p>
                    </div> */}
                </div>

                <div className="menu-icon" onClick={() => toggleSidebar(sidebarType)}>
                    ☰
                </div>

            </header>
        </div>
    )
}

